import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityModuleTag, SecurityRight } from '../security.module';
import { AIAgentSecurityRight } from './ai.agent.security.module.enums';

export class AIAgentSecurityModule extends BaseSecurityModule<AIAgentSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.AIAgent,
            [
                { _id: AIAgentSecurityRight.CanUseAgent, name: 'Use AI Agent', basic: true },
                { _id: AIAgentSecurityRight.AccessJobs, name: 'Access Jobs', basic: false },
                { _id: AIAgentSecurityRight.AccessCRM, name: 'Access CRM', basic: false },
                { _id: AIAgentSecurityRight.AccessFinance, name: 'Access Finance', basic: false },
                { _id: AIAgentSecurityRight.AccessCatalogue, name: 'Access Catalogue', basic: false },
                { _id: AIAgentSecurityRight.AccessDocs, name: 'Access Documentation', basic: false },
                { _id: AIAgentSecurityRight.AccessEquipment, name: 'Access Equipment', basic: false },
                { _id: AIAgentSecurityRight.AccessQuotes, name: 'Access Quotes', basic: false },
                { _id: AIAgentSecurityRight.AccessScheduler, name: 'Access Scheduler', basic: false },
                { _id: AIAgentSecurityRight.WriteJobs, name: 'Edit Jobs', basic: false },
                { _id: AIAgentSecurityRight.WriteCRM, name: 'Edit CRM', basic: false },
                { _id: AIAgentSecurityRight.WriteFinance, name: 'Edit Finance', basic: false },
                { _id: AIAgentSecurityRight.WriteJobDescription, name: 'Edit Job Descriptions', basic: false },
                { _id: AIAgentSecurityRight.WriteJobNotes, name: 'Add Job Activity Notes', basic: false },
                { _id: AIAgentSecurityRight.WriteJobLineItems, name: 'Add Line Items to Jobs', basic: false },
                { _id: AIAgentSecurityRight.WriteJobStageDates, name: 'Update Stage Dates', basic: false },
                { _id: AIAgentSecurityRight.WriteJobStageOrder, name: 'Update Stage Order', basic: false },
                { _id: AIAgentSecurityRight.WriteCrmAccounts, name: 'Create CRM Accounts', basic: false },
                { _id: AIAgentSecurityRight.WriteBillScan, name: 'Scan Bills', basic: false },
                { _id: AIAgentSecurityRight.WriteJobDetails, name: 'Edit Job Details', basic: false },
                { _id: AIAgentSecurityRight.WriteJobAssignments, name: 'Reassign Jobs', basic: false },
                { _id: AIAgentSecurityRight.WriteJobSite, name: 'Change Job Site', basic: false },
                { _id: AIAgentSecurityRight.WriteJobStatus, name: 'Change Job Status', basic: false },
                { _id: AIAgentSecurityRight.WriteWorkOrderStatus, name: 'Change Stage Status', basic: false },
                { _id: AIAgentSecurityRight.WriteStageRename, name: 'Rename Jobs & Stages', basic: false },
                { _id: AIAgentSecurityRight.WriteStageAssignment, name: 'Assign Stages', basic: false },
                { _id: AIAgentSecurityRight.WriteStageCategory, name: 'Update Stage Category', basic: false },
                { _id: AIAgentSecurityRight.WriteTasks, name: 'Manage Tasks', basic: false },
                { _id: AIAgentSecurityRight.WriteInvoiceCreate, name: 'Create Invoices (AI)', basic: false },
                { _id: AIAgentSecurityRight.WriteInvoiceEdit, name: 'Edit Invoices (AI)', basic: false },
                { _id: AIAgentSecurityRight.WriteInvoiceLineItems, name: 'Modify Invoice Line Items (AI)', basic: false },
                { _id: AIAgentSecurityRight.WriteInvoiceSend, name: 'Send Invoices (AI)', basic: false },
                { _id: AIAgentSecurityRight.WriteInvoiceSync, name: 'Sync Invoices to Accounting (AI)', basic: false },
                { _id: AIAgentSecurityRight.SkillWbfFormBuilder, name: 'WBF Form Builder Skill', basic: false },
                { _id: AIAgentSecurityRight.SkillStageScheduling, name: 'Stage Scheduling Skill', basic: false },
            ] as SecurityRight<AIAgentSecurityRight>[]
        );

        this.tags = [SecurityModuleTag.Test];
    }

}
